import {
  CopilotDocumentCategorySuggestion,
  CopilotDocumentIngest,
  CopilotDocumentIngestPayload,
  CopilotDocumentIngestResult,
} from 'models/copilot/copilotDocumentIngest';
import {
  CopilotDocumentCategorySuggestionDTO,
  CopilotDocumentIngestDTO,
  CopilotDocumentIngestPayloadDTO,
  CopilotDocumentIngestResultDTO,
} from 'models/dto/copilot/copilotDocumentIngestDTO';
import { mapFromCopilotGeneric } from './copilotMapping';

export function mapToCopilotDocumentIngest(item: CopilotDocumentIngest): CopilotDocumentIngestDTO {
  const output = new CopilotDocumentIngestDTO();
  output.sessionId = item.sessionId;
  output.contextKey = item.contextKey;
  output.sourceType = item.sourceType;
  output.storageSourceType = item.storageSourceType;
  output.uploadedBlobName = item.uploadedBlobName;
  output.libraryLinkId = item.libraryLinkId;
  output.libraryListId = item.libraryListId;
  output.title = item.title;
  output.fileName = item.fileName;
  output.mimeType = item.mimeType;
  output.markdown = item.markdown;
  output.suggestedListId = item.suggestedListId;
  output.saveToLibraryListId = item.saveToLibraryListId;
  output.categorySuggestion = mapToCopilotDocumentCategorySuggestion(item.categorySuggestion);

  return output;
}

export function mapFromCopilotDocumentIngestResult(item: CopilotDocumentIngestResultDTO): CopilotDocumentIngestResult {
  const output = new CopilotDocumentIngestResult();
  output.status = item.status;
  output.message = item.message;
  output.content = item.content ? mapFromCopilotGeneric(item.content) : undefined;
  output.payload = mapFromCopilotDocumentIngestPayload(item.payload);
  output.pendingIngest = mapFromCopilotDocumentIngest(item.pendingIngest);
  output.categorySuggestion = mapFromCopilotDocumentCategorySuggestion(item.categorySuggestion);

  return output;
}

function mapFromCopilotDocumentIngest(item: CopilotDocumentIngestDTO | undefined): CopilotDocumentIngest | undefined {
  if (!item) return undefined;

  const output = new CopilotDocumentIngest();
  output.sessionId = item.sessionId;
  output.contextKey = item.contextKey;
  output.sourceType = item.sourceType;
  output.storageSourceType = item.storageSourceType;
  output.uploadedBlobName = item.uploadedBlobName;
  output.libraryLinkId = item.libraryLinkId;
  output.libraryListId = item.libraryListId;
  output.title = item.title;
  output.fileName = item.fileName;
  output.mimeType = item.mimeType;
  output.markdown = item.markdown;
  output.suggestedListId = item.suggestedListId;
  output.saveToLibraryListId = item.saveToLibraryListId;
  output.categorySuggestion = mapFromCopilotDocumentCategorySuggestion(item.categorySuggestion);

  return output;
}

function mapToCopilotDocumentCategorySuggestion(
  item: CopilotDocumentCategorySuggestion | undefined,
): CopilotDocumentCategorySuggestionDTO | undefined {
  if (!item) return undefined;

  const output = new CopilotDocumentCategorySuggestionDTO();
  output.listId = item.listId;
  output.listName = item.listName;
  output.confidence = item.confidence;
  output.rationale = item.rationale;

  return output;
}

function mapFromCopilotDocumentCategorySuggestion(
  item: CopilotDocumentCategorySuggestionDTO | undefined,
): CopilotDocumentCategorySuggestion | undefined {
  if (!item) return undefined;

  const output = new CopilotDocumentCategorySuggestion();
  output.listId = item.listId;
  output.listName = item.listName;
  output.confidence = item.confidence;
  output.rationale = item.rationale;

  return output;
}

function mapFromCopilotDocumentIngestPayload(
  item: CopilotDocumentIngestPayloadDTO | undefined,
): CopilotDocumentIngestPayload | undefined {
  if (!item) return undefined;

  const output = new CopilotDocumentIngestPayload();
  output.sourceType = item.sourceType;
  output.storageSourceType = item.storageSourceType;
  output.tempBlobName = item.tempBlobName;
  output.tempBlobExpires = item.tempBlobExpires;
  output.originalLibraryLinkId = item.originalLibraryLinkId;
  output.originalLibraryListId = item.originalLibraryListId;
  output.suggestedListId = item.suggestedListId;
  output.sourceTitle = item.sourceTitle;
  output.sourceFileName = item.sourceFileName;
  output.mimeType = item.mimeType;

  return output;
}
